import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EventsMinimalQueryVariables = Types.Exact<{
  range?: Types.InputMaybe<Types.Range>;
}>;


export type EventsMinimalQuery = { __typename?: 'Query', events?: Array<{ __typename?: 'Event', id: string, name?: string | null, image_url?: string | null, start_date?: string | null, end_date?: string | null }> | null };


export const EventsMinimalDocument = gql`
    query eventsMinimal($range: Range) {
  events(range: $range) {
    id
    name
    image_url
    start_date
    end_date
  }
}
    `;

/**
 * __useEventsMinimalQuery__
 *
 * To run a query within a React component, call `useEventsMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsMinimalQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useEventsMinimalQuery(baseOptions?: Apollo.QueryHookOptions<EventsMinimalQuery, EventsMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsMinimalQuery, EventsMinimalQueryVariables>(EventsMinimalDocument, options);
      }
export function useEventsMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsMinimalQuery, EventsMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsMinimalQuery, EventsMinimalQueryVariables>(EventsMinimalDocument, options);
        }
export type EventsMinimalQueryHookResult = ReturnType<typeof useEventsMinimalQuery>;
export type EventsMinimalLazyQueryHookResult = ReturnType<typeof useEventsMinimalLazyQuery>;
export type EventsMinimalQueryResult = Apollo.QueryResult<EventsMinimalQuery, EventsMinimalQueryVariables>;